import React from 'react';
import { i18n_number_of_times_class_has_been_watched } from '@yi/i18n/phrases/i18n_number_of_times_class_has_been_watched';

import { Author, Container, Heading, Row, Tooltip } from './elements';
import { AuthorNameLight, Avatar } from '../../../../ClassIconComponents';
import { AddToCalendarMenu, ContentCardMenu } from '../../../../ContentCardMenu';
import { useLocale } from '../../../../LocaleProvider';
import { LocalizedLink } from '../../../../LocalizedLink';
import { ViewCount } from '../../../../ViewCount';
import {
  extractCompletedCount,
  extractContentId,
  extractTeacher,
  extractTitle,
} from '../../content-utils';
import { Content } from '../../types';

export const DetailsPanel: React.FC<{
  content: Content;
}> = ({ content }) => {
  const contentId = extractContentId(content);
  const title = extractTitle(content);
  const completedCount = extractCompletedCount(content);
  const teacher = extractTeacher(content);
  const { locale } = useLocale();
  return (
    <Container>
      <Row>
        <Tooltip
          disableInteractive
          placement="top-start"
          title={i18n_number_of_times_class_has_been_watched(locale)}
          PopperProps={{ disablePortal: true }}
        >
          <div>
            <ViewCount count={completedCount} />
          </div>
        </Tooltip>
        <div>
          <ContentCardMenu contentId={contentId} contentTitle={title} playerMode>
            <AddToCalendarMenu playerMode />
          </ContentCardMenu>
        </div>
      </Row>
      <Heading>{title}</Heading>
      <Author>
        <Avatar
          imgProps={{ role: 'presentation' }}
          style={{ display: 'inline-flex' }}
          src={teacher?.image?.processed_url}
          aria-label="teacher avatar"
        />
        <AuthorNameLight>
          {teacher && (
            <LocalizedLink to={`/profile/${teacher.url_title}`} aria-label="teacher profile link">
              {teacher.full_name}
            </LocalizedLink>
          )}
        </AuthorNameLight>
      </Author>
    </Container>
  );
};
